/* eslint-disable*/
import React, { useEffect, useState } from 'react';

import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';

import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import { useTranslation } from 'react-i18next';
import {
  CardContentContainer,
  CardContentSubtitle,
  CardContentFee,
  CardContentTitle,
  CardImgContainer,
  EnrollCardContainer,
  ImgBox,
  FallbackImg,
  NotAvailableBenefit,
  NotAvailableText,
  NotAvailableBalloon,
  CardContentCoverage,
} from './styles';
import { benefitsForbiddenWords } from '../..';

type EnrollCardProps = {
  title: string;
  subtitle: string;
  fee: string | number;
  coverage?: string | number;
  imgURL?: string;
  selected?: boolean;
  disabled?: boolean;
  onSelect?: Function;
  enrollable?: boolean;
  employeeChoosesPayment?: 'Yes' | 'No' | undefined;
  costCalculationMethod?: string;
};

const EnrollCard: React.FC<EnrollCardProps> = ({
  title,
  subtitle,
  fee,
  coverage,
  imgURL,
  enrollable,
  selected = false,
  disabled = false,
  onSelect,
  employeeChoosesPayment,
  costCalculationMethod,
}) => {
  const [isSelected, setSelected] = useState(selected);
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setSelected(selected);
  }, [selected]);

  const handleSelection = () => {
    if (disabled) return;

    if (onSelect) {
      onSelect(title);
    }
  };

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <EnrollCardContainer
      disable={disabled}
      selected={isSelected}
      onClick={handleSelection}
      enrollable={enrollable as unknown as false}
    >
      <CardContentContainer>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CardContentTitle>{removeForbiddenWords(title, benefitsForbiddenWords)}</CardContentTitle>
          {enrollable ? (
            ''
          ) : (
            <NotAvailableBenefit onMouseLeave={() => setHover(false)} onMouseOver={() => setHover(true)}>
              <NotAvailableText>{t('benefits.benefit.notAvailable')}</NotAvailableText>
              <NotAvailableBalloon style={{ display: hover ? 'block' : 'none' }}>
                {t('benefits.benefit.notAvailableBalloon')}
              </NotAvailableBalloon>
            </NotAvailableBenefit>
          )}
        </div>
        <CardContentSubtitle>{subtitle}</CardContentSubtitle>

        {!employeeChoosesPayment || employeeChoosesPayment == 'No' ? (
          <CardContentFee>{costCalculationMethod?.toLocaleLowerCase() === 'table' ? '' : fee}</CardContentFee>
        ) : (
          ''
        )}
        {coverage ? (
          <CardContentCoverage>
            {t('benefits.benefit.coverageAmount')}
            {coverage}
          </CardContentCoverage>
        ) : (
          ''
        )}
      </CardContentContainer>
    </EnrollCardContainer>
  );
};

export default EnrollCard;
